var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent", staticStyle: { height: "calc(100vh - 50px)" } },
    [
      _c("dialogue", {
        attrs: {
          title: "Preparing",
          paragraph: "Preparing invoice, this may take a while",
          show: _vm.prepare_dialogue
        }
      }),
      _vm._v(" "),
      _c("layout-3", {
        staticStyle: { "max-height": "30vh" },
        attrs: { id: _vm.pageid1, term: _vm.term, width: 3, height: 2 }
      }),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "margin-left": "25px", "margin-right": "25px" }
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", {
        staticStyle: {
          height: "30px",
          padding: "0px 15px 0px 15px",
          "font-size": "16px"
        },
        attrs: { id: "jobInfoText" }
      }),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "margin-left": "25px", "margin-right": "25px" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "overflow-y": "auto", "margin-bottom": "10px" } },
        [
          _vm.termSplit[1] == "4"
            ? _c("div", { key: _vm.update_key }, [
                _c(
                  "div",
                  { staticClass: "lefttable" },
                  [
                    _c("layout-1", {
                      attrs: {
                        table_name: "Job Orders Assigned To Contract",
                        id: _vm.pageid3,
                        searchbar: false,
                        height_limit: false,
                        auto_reload: false,
                        button_perm: "83",
                        button_name: "Remove",
                        term: _vm.termSplit
                      },
                      on: { select: _vm.selectLink }
                    }),
                    _vm._v(" "),
                    _c("layout-1", {
                      attrs: {
                        table_name: "Available Job Orders",
                        id: _vm.pageid2,
                        searchbar: false,
                        height_limit: false,
                        auto_reload: false,
                        button_perm: "83",
                        button_name: "Add",
                        term: _vm.termSplit
                      },
                      on: { select: _vm.select }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "righttable" },
                  [
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticStyle: { float: "left", width: "100px" },
                          on: {
                            click: function($event) {
                              return _vm.changePage(-1)
                            }
                          }
                        },
                        [_vm._v("<")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticStyle: { float: "right", width: "100px" },
                          on: {
                            click: function($event) {
                              return _vm.changePage(1)
                            }
                          }
                        },
                        [_vm._v(">")]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticStyle: {
                            margin: "0 auto 0 auto",
                            width: "100px",
                            "text-align": "center"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.invDocPage) +
                              " / " +
                              _vm._s(_vm.documents.length)
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.invDocPage == 0
                      ? _c("layout-13", {
                          staticStyle: { width: "100%" },
                          attrs: { term: _vm.termSplit, showMiscText: true }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.documents, function(documentid, index) {
                      return index + 1 == _vm.invDocPage
                        ? _c(
                            "div",
                            {
                              staticClass: "scroll",
                              staticStyle: {
                                width: "95%",
                                height: "calc(100vh - 225px)"
                              }
                            },
                            [
                              _c("document", {
                                attrs: {
                                  id: index,
                                  dir: "doc_" + documentid + ".jpg",
                                  doc_id: documentid
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    })
                  ],
                  2
                )
              ])
            : _c("layout-1", {
                attrs: {
                  table_name: "Job Orders",
                  id: _vm.pageid2,
                  searchbar: false,
                  height_limit: false,
                  navbar: false,
                  select_reroute: true,
                  button_perm: "83",
                  button_name: "Select",
                  term: _vm.termSplit
                }
              })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "nav-bar" }, [
        _c("div", [
          _c(
            "button",
            {
              on: {
                click: function($event) {
                  return _vm.prepareInvoice()
                }
              }
            },
            [_vm._v("Prepare Invoice")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              on: {
                click: function($event) {
                  return _vm.addAll()
                }
              }
            },
            [_vm._v("Add All Available Job Orders")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              on: {
                click: function($event) {
                  return _vm.removeAll()
                }
              }
            },
            [_vm._v("Remove All Assigned Job Orders")]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          height: "12px",
          padding: "0px 15px 0px 15px",
          "font-size": "10px"
        }
      },
      [_c("b", [_vm._v("Master Job Order")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e85225e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e85225e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/View_Contracts.vue
// module id = 564
// module chunks = 0